<template>
    <div>
        <h1>Settings View</h1>

    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>